import { render, staticRenderFns } from "./recordData.vue?vue&type=template&id=2cd6e13c&"
import script from "./recordData.vue?vue&type=script&lang=js&"
export * from "./recordData.vue?vue&type=script&lang=js&"
import style0 from "./recordData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports